export interface PriceLogic {
  title: string
  percent: number
}

export function parsePriceLogic(logic: string): PriceLogic | null {
  const prefix = 'price - '
  const separator = ' - '

  if (!logic) {
    return null
  }

  const value = logic.trim()
  if (!value.startsWith(prefix)) {
    return null
  }

  const body = value.slice(prefix.length)
  const lastSeparator = body.lastIndexOf(separator)
  if (lastSeparator < 0) {
    return null
  }

  const title = body.slice(0, lastSeparator).trim()
  const percentValue = body
    .slice(lastSeparator + separator.length)
    .replace('%', '')
    .trim()
  const percent = Number(percentValue)

  if (!title || isNaN(percent)) {
    return null
  }

  return { title, percent }
}
